import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { UiBlocker } from '@bingads-webui-react/ui-blocker';
import { withI18nConsumer } from '@bingads-webui-react/i18n-context';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { Button } from '@bingads-webui-react/primitive';
import classNames from 'classnames';
import { getBaseEditorStyle } from '../styles';

// TODO: this is a shared editor footer, migrigated it to shared component later.
class BaseEditorInternal extends React.Component {
  static propTypes = {
    i18n: PropTypes.shape({
      getString: PropTypes.func,
    }).isRequired,
    classes: PropTypes.shape({}).isRequired,
    onSave: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    children: PropTypes.node.isRequired,
    isValid: PropTypes.bool.isRequired,
    isLoading: PropTypes.bool.isRequired,
  };

  onSave() {
    this.props.onSave();
  }

  onCancel() {
    this.props.onCancel();
  }

  render() {
    const {
      i18n, classes, children, isValid, isLoading,
    } = this.props;

    return (
      <UiBlocker
        style={{ display: 'flex', height: '100%', flexFlow: 'column' }}
        blocking={isLoading}
        loadingText={i18n.getString(_TL_('Loading...'))}
      >
        <div className={classes.content}>
          {children}
        </div>
        <div className={classes.formFooter}>
          <Button
            className={classNames(classes.saveButton, 'save', 'shared-budget-edit-budget-save')}
            disabled={!isValid}
            onClick={() => this.onSave()}
          >{i18n.getString(_TL_('Save'))}
          </Button>
          <Button
            className={classNames(classes.cancelButton, 'cancel', 'shared-budget-edit-budget-cancel')}
            onClick={() => this.onCancel()}
          >{i18n.getString(_TL_('Cancel'))}
          </Button>
        </div>
      </UiBlocker>
    );
  }
}

const wrappers = [
  withI18nConsumer,
  _.partial(withDefaultStyles, _, getBaseEditorStyle),
];

const Wrapped = _.compose(...wrappers)(BaseEditorInternal);

export const KEYSENTER = 13;
export { Wrapped as BaseEditor };
